import React from 'react';

import { Typography } from 'ucl/components/text/Typography';

import { primitive } from 'styles/constants';

export const StyledRewardPointCost = ({
  usePrimaryColor,
  ...props
}: React.ComponentPropsWithoutRef<typeof Typography> & { usePrimaryColor?: boolean }) =>
  React.createElement(Typography, {
    style: { textTransform: 'capitalize', fontWeight: primitive.$fontWeightHeavy },
    ...(usePrimaryColor ? { color: primitive.$fieryRed } : {}),
    ...props,
  });
